<script setup lang="ts">
import BaseButton from '@/components/ui/buttons/BaseButton.vue';
import { ref, watch } from 'vue';
import { ListTask } from "@/interfaces/data-contracts";
import adminAPI from '@/services/api';
import AlertModal from '@/components/ui/modals/AlertModal.vue';
import BaseInput from '@/components/ui/inputs/BaseInput.vue';
import Select from '../ui/select/Select.vue';
import { ClockIcon } from '@heroicons/vue/24/solid';
import { useNotificationStore } from '@/store';
import { ForwardIcon } from 'lucide-vue-next';

const props = defineProps<{ claimId: string; open: boolean}>();
const emit = defineEmits(['close']);

const dueDateOptions = [
  { value: "in two hours", label: "Dans 2 heures" },
  { value: "tomorrow at 11", label: "Demain" },
  { value: "next monday", label: "Lundi prochain" },
  { value: "in 1 week", label: "Dans 1 semaine" },
  { value: "in two weeks", label: "Dans 2 semaines" },
  { value: "next month", label: "Dans 1 mois" },
]

const defaultTask = ref({
  title: "",
  dueDate: null,
  dueDateString: "next monday",
});

const loading = ref(false)
const task = ref(defaultTask);

async function createClaimTask() {
  try {
    loading.value = true;

    await adminAPI.upsertTask(props.claimId, {
      assignedAdminId: "1c444168-774b-4915-bf95-92385fc96c69", // @TODO: Select
      title: task.value.title,
      dueDate: task.value.dueDate || undefined,
      dueDateString: task.value.dueDateString,
    });

    useNotificationStore().emitNotification({
      title: `Rappel créé avec succès`
    })

  } catch {

  } finally {
    loading.value = false;
    emit('close');
    task.value = defaultTask.value;
  }
}
</script>

<template>
  <AlertModal
    :open="open"
    type="info"
    title="Créer un rappel"
    confirm-message=""
    @close="$emit('close')"
    @cancel="$emit('close')"
    @confirm="$emit('close')"
    width="max-w-2xl"
  >
  
  <div>
    <form class="divide-y-8 divide-transparent">
      <BaseInput label="Titre" placeholder="Description du rappel" v-model="task.title" />
      <div>
        <Select
          :icon="ClockIcon"
          label="Me le rappeler dans :"
          @update:modelValue="selected => task.dueDateString = selected.value"
          :options="dueDateOptions"
          :selected-option="2"
          :block="true"
      />
      </div>
      <div class="my-2">
        <label for="eventDate" class="block text-sm text-gray-700">
         <spa class="italic text-gray-500">Ou, date personnalisée (optionnel)</spa>
        </label>
          <VueDatePicker
            v-tooltip="`Date du dernier message reçu par défault`"
            v-model="task.dueDate"
            auto-apply
            :close-on-auto-apply="true"
            :min-date="new Date()"
            :start-time="{ hours: 8, minutes: 0 }"
            :end-time="{ hours: 19, minutes: 0 }"
            format="dd/MM/yyyy"
            text-input placeholder="Date du rappel"
            locale="fr" cancelText="Annuler" selectText="Valider"
          />
      </div>
      <div class="flex justify-center mt-6">
        <BaseButton text="Créer le rappel" type="submit" @click="createClaimTask" :loading="loading" :icon="ForwardIcon" size="lg" />
      </div>
    </form>
  
  </div>
  
  </AlertModal>

</template>